
/* styles */
require("!!../../../node_modules/.1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?sourceMap!../../../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-0555d758!stylus-loader?sourceMap!../../../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./DuoShuo.vue")

var Component = require("!../../../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./DuoShuo.vue"),
  /* template */
  require("!!../../../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-0555d758!../../../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./DuoShuo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/DuoShuo.vue
// module id = 69
// module chunks = 2